/* eslint-disable max-lines */
import { css } from 'linaria';

export const categoriesSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--to-desktop) {
    margin-bottom: 56px;
  }
`;

export const categoryTabList = css`
  && {
    justify-content: center;
    margin-bottom: 48px;

    button {
      border-bottom: solid 2px var(--control-primary);
      box-shadow: none;
    }

    button[aria-selected='false'] {
      border-bottom: solid 2px var(--control-minor);
    }

    @media (--to-desktop) {
      margin-bottom: 32px;
    }
  }
`;

export const inactiveCategoryTab = css`
  font-weight: 500;
  font-size: 26px;
  line-height: 32px;
  color: inherit;

  @media (--only-mobile) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const categoriesWrapper = css`
  display: grid;
  grid-template-columns: 574px 574px;
  grid-template-rows: 336px 609px;
  column-gap: 32px;
  row-gap: 37px;

  @media (--only-desktop) {
    grid-template-columns: 454px 454px;
    grid-template-rows: 336px 737px;
    row-gap: 32px;
  }

  @media (--only-tablet) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 526px);
    row-gap: 32px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    row-gap: 24px;
  }
`;

export const bigCategoryCard = css`
  @media (--from-desktop) {
    grid-column: 1 / -1;
    border-radius: var(--rounding-l);
  }
`;

export const cardMediaWrapper = css`
  width: 100%;
  height: 289px;

  @media (--only-tablet) {
    min-height: unset;
    height: 238px;
  }

  @media (--only-mobile) {
    height: 146px;
    margin-bottom: 24px;
  }
`;

export const bigCardMediaWrapper = css`
  @media (--from-desktop) {
    position: relative;
    height: 336px;
  }
`;

export const categoryImage = css`
  && {
    width: 100%;
    height: 289px;

    @media (--only-tablet) {
      width: 100%;
      height: 238px;
    }

    @media (--only-mobile) {
      height: 146px;
      border-radius: var(--rounding-l);
    }
  }
`;

export const categoryMedia = css`
  && {
    @media (--only-mobile) {
      border-radius: unset;
      box-shadow: unset;
    }
  }
`;

export const bigCategoryMedia = css`
  && {
    @media (--from-desktop) {
      height: 336px;
      border-radius: var(--rounding-l);
    }
  }
`;

export const bigCategoryContent = css`
  @media (--from-desktop) {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border: none;
  }
`;

export const bigCategoryText = css`
  && {
    @media (--from-desktop) {
      color: var(--text-invert);
    }
  }
`;

export const categoryCardContent = css`
  && {
    padding: 40px;

    @media (--only-mobile) {
      padding: 0;
    }
  }
`;

export const categoryTitle = css`
  && {
    margin-bottom: 32px;

    @media (--to-desktop) {
      margin-bottom: 16px;
    }
  }
`;

export const categoryListStyle = css`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 231px 231px;
  grid-template-rows: repeat(4, 40px);
  padding: 0;
  margin: 0;
  column-gap: 32px;
  list-style: none;
  row-gap: 8px;

  @media (--only-desktop) {
    grid-template-columns: 100%;
    grid-template-rows: repeat(8, 40px);
    row-gap: 0;
  }

  @media (--only-tablet) {
    grid-template-columns: 278px 278px;
    column-gap: 24px;
    row-gap: 0;
  }

  @media (--only-mobile) {
    grid-template-columns: 100%;
    grid-template-rows: repeat(8, 40px);
    row-gap: 0;
  }
`;

export const bigCategoryListStyle = css`
  @media (--only-desktop) {
    grid-template-columns: 231px 231px;
    grid-template-rows: repeat(4, 40px);
    row-gap: 8px;
  }
`;

export const categoryItemStyle = css`
  display: flex;
  align-items: center;
`;

export const categoryLink = css`
  display: inline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);

  &:hover {
    color: var(--brand-dark);
  }
`;
